import {Injectable} from '@angular/core';

@Injectable()
export class ObjectMapService {

   shallowCompare(map1, map2) {
    for (const key in map1) {
      if (map1.hasOwnProperty(key)) {
        const val = map1[key];
        const m2Value = map2[key];
        // in cases of an undefined value, make sure the key
        // actually exists on the object so there are no false positives
        if (m2Value !== val || (m2Value === undefined && !map2[key]))
          return false;
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/object-map/object-map.service.ts